// Sepet sayfasında add to cart butonlarını kaldır
function removeCartPageButtons() {
  // Sayfanın sepet sayfası olup olmadığını kontrol et
  if (window.location.pathname.includes('/cart')) {
    // Tüm add to cart butonlarını ve ilgili elementleri bul ve kaldır
    const elementsToRemove = document.querySelectorAll('.product-card__actions, .product-options, .add-to-cart-btn, .options-row');
    elementsToRemove.forEach(element => {
      if (element && element.parentNode) {
        element.parentNode.removeChild(element);
      }
    });

    // has-long-flavor sınıfını içeren elementleri bul ve kaldır
    const longFlavorElements = document.querySelectorAll('.has-long-flavor');
    longFlavorElements.forEach(element => {
      if (element && element.parentNode) {
        element.parentNode.removeChild(element);
      }
    });
  }
}

// Sayfa yüklendiğinde çalıştır
document.addEventListener('DOMContentLoaded', removeCartPageButtons);

// AJAX ile sayfa güncellendiğinde tekrar çalıştır
document.addEventListener('cart:updated', removeCartPageButtons);

// Sepetten ürün kaldırıldığında tekrar çalıştır
document.addEventListener('cart:refresh', removeCartPageButtons);

// Desktop Buy Item Button Functionality
document.addEventListener('DOMContentLoaded', function() {
  // Metin kısaltma fonksiyonu
  function truncateText(text, maxLength) {
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength - 3) + '...';
  }

  // Flavor seçici metinlerini düzenle
  function formatFlavorOptions() {
    document.querySelectorAll('.flavor-select option').forEach(option => {
      const originalText = option.getAttribute('data-original-text') || option.textContent;
      option.setAttribute('data-original-text', originalText);
      
      // Metin uzunluğunu kontrol et ve sadece uzun metinleri kısalt
      if (originalText.length > 40) {
        option.textContent = originalText.substring(0, 37) + '...';
      } else {
        option.textContent = originalText; // Kısa metinleri olduğu gibi bırak
      }
      
      option.title = originalText; // Tam metni tooltip olarak göster
    });
  }

  // Flavor filtrelerini yeniden oluştur ve etkinleştir
  function initializeFlavorFilters() {
    const flavorCheckboxes = document.querySelectorAll('input.flavor-filter-checkbox');
    const products = document.querySelectorAll('.product-item');
    
    function updateProductVisibility() {
      const selectedFlavors = Array.from(flavorCheckboxes)
        .filter(cb => cb.checked)
        .map(cb => cb.getAttribute('data-flavor'));

      if (selectedFlavors.length === 0) {
        products.forEach(product => {
          if (product) product.style.display = '';
        });
        return;
      }

      products.forEach(product => {
        if (!product) return;
        
        const flavorSelect = product.querySelector('.flavor-select');
        if (!flavorSelect) {
          product.style.display = 'none';
          return;
        }

        const productFlavors = Array.from(flavorSelect.options)
          .filter(option => option.value !== '') // Filter out empty options
          .map(option => {
            // Get the original text if available, otherwise use the option text
            return (option.getAttribute('data-original-text') || option.textContent).trim();
          });

        const hasSelectedFlavor = selectedFlavors.some(selectedFlavor => 
          productFlavors.some(productFlavor => 
            productFlavor.includes(selectedFlavor)
          )
        );

        product.style.display = hasSelectedFlavor ? '' : 'none';
      });
    }

    flavorCheckboxes.forEach(checkbox => {
      if (checkbox) {
        // Önceki event listener'ları kaldır
        checkbox.removeEventListener('change', updateProductVisibility);
        // Yeni event listener ekle
        checkbox.addEventListener('change', updateProductVisibility);
      }
    });

    const toggleButtons = document.querySelectorAll('.toggle-filter');
    toggleButtons.forEach(button => {
      if (button) {
        button.addEventListener('click', function(e) {
          e.preventDefault();
          const checkboxes = this.closest('.flavor-filter').querySelector('.flavor-checkboxes');
          const isExpanded = this.getAttribute('aria-expanded') === 'true';
          
          this.setAttribute('aria-expanded', !isExpanded);
          if (checkboxes) checkboxes.classList.toggle('show');
        });
      }
    });
  }

  // Sayfa yüklendiğinde ve flavor değiştiğinde metinleri düzenle
  formatFlavorOptions();
  initializeFlavorFilters();

  // Tüm sayfalarda flavor seçicileri için formatFlavorOptions fonksiyonunu çağır
  document.addEventListener('change', function(e) {
    if (e.target && e.target.classList.contains('flavor-select')) {
      formatFlavorOptions();
    }
  });

  // Uzun flavor metinlerini kontrol et ve gerekli sınıfı ekle
  function checkFlavorTextLength() {
    document.querySelectorAll('.flavor-select').forEach(select => {
      const options = Array.from(select.options);
      const hasLongText = options.some(option => option.textContent.length > 30);
      const actionsContainer = select.closest('.product-card__actions');
      
      if (hasLongText) {
        actionsContainer.classList.add('has-long-flavor');
      } else {
        actionsContainer.classList.remove('has-long-flavor');
      }
    });
  }

  // Sayfa yüklendiğinde kontrol et
  checkFlavorTextLength();

  // Add to Cart functionality - only initialize on collection pages
  function initializeAddToCartButtons() {
    // Only initialize on collection pages - check both URL and body class
    const isCollectionPage = window.location.pathname.includes('/collections/') || 
                            document.body.classList.contains('template-collection');
    
    if (!isCollectionPage) {
      return;
    }
    
    document.querySelectorAll('.add-to-cart-btn').forEach(button => {
      if (!button) return;
      
      // Önceki event listener'ları kaldır
      button.replaceWith(button.cloneNode(true));
      const newButton = document.querySelector(`[data-product-id="${button.getAttribute('data-product-id')}"]`);
      
      if (newButton) {
        newButton.addEventListener('click', function(e) {
          e.preventDefault();
          const productCard = this.closest('.product-card__actions');
          if (!productCard) return;
          
          const productOptions = productCard.querySelector('.product-options');
          if (!productOptions) return;
          
          const state = this.getAttribute('data-state');
          
          if (state === 'initial') {
            // Show options
            productOptions.style.display = 'block';
            
            // Ensure both quantity and flavor selectors are visible
            const quantitySelector = productOptions.querySelector('.quantity-selector');
            const flavorSelector = productOptions.querySelector('.flavor-selector');
            
            if (quantitySelector) quantitySelector.style.display = 'block';
            if (flavorSelector) flavorSelector.style.display = 'block';
            
            // Update button state
            this.setAttribute('data-state', 'ready');
            this.style.backgroundColor = '#000000';
            this.style.color = '#ffffff';
          } else {
            const quantitySelect = productCard.querySelector('.quantity-select');
            const flavorSelect = productCard.querySelector('.flavor-select');
            
            // Ensure both selectors exist before proceeding
            if (!quantitySelect || !flavorSelect) {
              console.error('Required selectors not found');
              return;
            }
            
            const quantity = parseInt(quantitySelect.value) || 1;
            const variantId = flavorSelect.value || this.getAttribute('data-variant-id');
            
            if (!variantId) {
              console.error('No variant ID found');
              return;
            }
            
            addToCart(variantId, quantity);
          }
        });
      }
    });
  }

  // Initialize add to cart buttons
  initializeAddToCartButtons();

  // Handle flavor selection change - only on collection pages
  const isCollectionPage = window.location.pathname.includes('/collections/') || 
                          document.body.classList.contains('template-collection');
  
  if (isCollectionPage) {
    document.querySelectorAll('.flavor-select').forEach(select => {
      if (!select) return;
      
      select.addEventListener('change', function() {
        const selectedOption = this.options[this.selectedIndex];
        const inventory = parseInt(selectedOption.getAttribute('data-inventory'));
        const quantitySelect = this.closest('.options-row').querySelector('.quantity-select');
        const productCard = this.closest('.product-card__actions');
        
        if (quantitySelect) {
          quantitySelect.innerHTML = '';
          
          const maxQuantity = Math.min(inventory, 10);
          for(let i = 1; i <= maxQuantity; i++) {
            const option = document.createElement('option');
            option.value = i;
            option.textContent = i;
            quantitySelect.appendChild(option);
          }
        }

        if (productCard) {
          const addToCartBtn = productCard.querySelector('.add-to-cart-btn');
          if (addToCartBtn && selectedOption) {
            addToCartBtn.setAttribute('data-variant-id', selectedOption.value);
          }
        }
      });
    });
  }

  // Close options when clicking outside - only on collection pages
  if (isCollectionPage) {
    document.addEventListener('click', function(e) {
      const clickedElement = e.target;
      const productCardActions = clickedElement.closest('.product-card__actions');
      const flavorFilter = clickedElement.closest('.flavor-filter');
      
      if (flavorFilter || (productCardActions && !clickedElement.classList.contains('add-to-cart-btn'))) {
        return;
      }

      document.querySelectorAll('.product-options').forEach(options => {
        if (!options) return;
        
        const addToCartBtn = options.nextElementSibling;
        if (addToCartBtn && addToCartBtn.classList.contains('add-to-cart-btn')) {
          if (!productCardActions || (productCardActions && !productCardActions.contains(options))) {
            options.style.display = 'none';
            
            // Reset button state
            addToCartBtn.setAttribute('data-state', 'initial');
            addToCartBtn.style.backgroundColor = '#ffffff';
            addToCartBtn.style.color = '#000000';
            
            // Ensure selectors remain visible for next time
            const quantitySelector = options.querySelector('.quantity-selector');
            const flavorSelector = options.querySelector('.flavor-selector');
            
            if (quantitySelector) quantitySelector.style.display = 'block';
            if (flavorSelector) flavorSelector.style.display = 'block';
          }
        }
      });
    });
  }

  document.querySelectorAll('.add-to-cart-final').forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      const productCard = this.closest('.product-card');
      const variantId = productCard.querySelector('.flavor-dropdown').value;
      
      // Add to cart logic
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: 1
          }]
        })
      })
      .then(() => {
        window.location.href = '/cart';
      })
      .catch(() => {
        window.location.href = '/cart';
      });
      
      this.closest('.flavor-selector').style.display = 'none';
    });
  });

  document.addEventListener('click', function(e) {
    if (!e.target.closest('.product-card__actions')) {
      document.querySelectorAll('.flavor-selector').forEach(selector => {
        selector.style.display = 'none';
      });
    }
  });

  // Sticky Add to Cart functionality
  const stickyBar = document.querySelector('.sticky-atc-bar');
  const productForm = document.querySelector('#add-item-form');
  
  if (stickyBar && productForm) {
    if (window.innerWidth >= 769) {
      // Desktop behavior
      const productFormOffset = productForm.offsetTop + productForm.offsetHeight;
      
      // Check position on page load
      if (window.pageYOffset > productFormOffset) {
        stickyBar.classList.add('show');
      }
      
      window.addEventListener('scroll', function() {
        if (window.pageYOffset > productFormOffset) {
          stickyBar.classList.add('show');
        } else {
          stickyBar.classList.remove('show');
        }
      });
    } else {
      // Mobile behavior - show by default
      stickyBar.style.display = 'block';
    }
  }
});

function addToCart(variantId, quantity) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      items: [{
        id: variantId,
        quantity: quantity
      }]
    })
  })
  .then(response => response.json())
  .then(data => {
    if(data.items) {
      window.location.href = '/cart';
    } else {
      console.error('Add to cart error:', data);
    }
  })
  .catch(error => {
    console.error('Add to cart error:', error);
  });
}

// Handle flavor selection change - only on collection pages
document.addEventListener('change', function(e) {
  // Only run on collection pages
  const isCollectionPage = window.location.pathname.includes('/collections/') || 
                          document.body.classList.contains('template-collection');
  
  if (!isCollectionPage) return;
  
  if (e.target && e.target.classList.contains('flavor-select')) {
    const flavorSelect = e.target;
    const productCard = flavorSelect.closest('.product-card__actions');
    if (!productCard) return;
    
    const quantitySelect = productCard.querySelector('.quantity-select');
    if (!quantitySelect) return;
    
    const selectedOption = flavorSelect.options[flavorSelect.selectedIndex];
    const inventory = selectedOption.getAttribute('data-inventory');
    
    // Update quantity selector based on inventory
    updateQuantityOptions(quantitySelect, inventory);
    
    // Update add to cart button variant ID
    const addToCartBtn = productCard.querySelector('.add-to-cart-btn');
    if (addToCartBtn) {
      addToCartBtn.setAttribute('data-variant-id', flavorSelect.value);
      addToCartBtn.setAttribute('data-inventory', inventory);
    }
  }
});

// Close options when clicking outside - only on collection pages
document.addEventListener('click', function(e) {
  // Only run on collection pages
  const isCollectionPage = window.location.pathname.includes('/collections/') || 
                          document.body.classList.contains('template-collection');
  
  if (!isCollectionPage) return;
  
  const productOptions = document.querySelectorAll('.product-options');
  const addToCartButtons = document.querySelectorAll('.add-to-cart-btn');
  
  let clickedInsideOptions = false;
  
  productOptions.forEach(options => {
    if (options.contains(e.target)) {
      clickedInsideOptions = true;
    }
  });
  
  addToCartButtons.forEach(button => {
    if (button.contains(e.target)) {
      clickedInsideOptions = true;
    }
  });
  
  if (!clickedInsideOptions) {
    productOptions.forEach(options => {
      options.style.display = 'none';
    });
    
    addToCartButtons.forEach(button => {
      button.setAttribute('data-state', 'initial');
      button.style.backgroundColor = '';
      button.style.color = '';
    });
  }
}); 